import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Contatti from "./pages/Contatti";
import ChiSiamo from "./pages/ChiSiamo";
import Prodotti from "./pages/Prodotti";
import Servizi from "./pages/Servizi";
import Cataloghi from "./pages/Cataloghi";
import NewsPage from "./pages/News";

function App() {
  return (
    <div className="App bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/prodotti" element={<Prodotti />} />
            <Route path="/prodotti/:slug" element={<Prodotti />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/cataloghi" element={<Cataloghi />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Contatti />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
